import { Container, List } from "@mui/material";

import {
  GetNoticeDefinitionDataDto,
  RenderNoticeTemplateDto,
  RenderPatientNoticeTemplateDto,
} from "../../api-client";
import NoticeRow from "./NoticeRow";

interface NoticeListProps {
  notices: GetNoticeDefinitionDataDto[];
  onRenderPatientNoticeTemplate: (data: RenderNoticeTemplateDto) => void;
  onUploadPatientNoticeTemplate: (file: File, noticeDefinitionDataId: string) => void;
}

// Notice List Component
const NoticeList = ({
  notices,
  onRenderPatientNoticeTemplate,
  onUploadPatientNoticeTemplate,
}: NoticeListProps) => {
  return (
    <List>
      {notices.map((notice) => (
        <NoticeRow
          key={notice.id}
          noticeDefinition={notice.noticeDefinition}
          onDownload={() =>
            onRenderPatientNoticeTemplate({
              noticeDefinitionDataId: notice.id,
              noticeType: notice.noticeDefinition.type,
            })
          }
          onUpload={(file: File) => {
            onUploadPatientNoticeTemplate(file, notice.id);
          }}
        />
      ))}
    </List>
  );
};

export default NoticeList;
